// extracted by mini-css-extract-plugin
export default {"header":"auth-panel_header__onABE","panel":"auth-panel_panel__tEnzn","message":"auth-panel_message__5PXlP"};